import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_CARD_INFO}`;

/** 取得信用卡持卡人資訊 */
export default () => axios.get(API_PATH);
